import './index.scss'

import { Button, Drawer, Form, Input, Rate } from 'antd'
import React from 'react'

import Container from '@ui-pc/Container'
import Flex from '@ui-pc/Flex'
import Icon from '@ui-pc/Icon'
import Image from '@ui-pc/Image'
import Switch from '@ui-pc/Switch'
import Text from '@ui-pc/Text'

import { ctx } from '../../utils'
import sucess from './Slice 4@2x.png'

const WritePanelv2 = (props: { onSubmit }) => {
  const { onSubmit } = props

  const [form] = Form.useForm()

  const [score, setState] = React.useState(5)

  const ref = ctx.useRef()

  const [state] = ctx.useState()

  return (
    <Flex
      className="write-panel-form"
      direction="column"
      rowGap={32}
      padding={[12, 0]}>
      <Flex id="write-panel-head" colGap={16} warp={false}>
        <Image
          alt={state.productsName}
          preview={false}
          src={state.mainImage}
          width="80"
          height="80"
        />
        <Flex span="auto" direction="column" rowGap={8}>
          <Text size={14} className="write-panel-title">
            {state.productsName}
          </Text>
          <Rate
            value={score}
            onChange={(num) => {
              setState(num)
            }}
          />
        </Flex>
      </Flex>
      <Flex>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          style={{ width: '100%' }}>
          <Flex direction="column" rowGap={12}>
            <Text className="wp-label">Add Your Review*</Text>
            <Text>You may want to talk about:</Text>
            <Flex span="auto" colGap={24} warp={false}>
              <Text type="secondary">•{'  '}Style</Text>
              <Text type="secondary">•{'  '}Quality</Text>
              <Text type="secondary">•{'  '}Value</Text>
            </Flex>
            <Form.Item
              name="content"
              style={{ width: '100%' }}
              //label={<Text className="wp-label">Add Your Review*</Text>}
              rules={[
                {
                  required: true,
                  message: 'Please enter the content of the comment'
                },
                { type: 'string', min: 6, max: 2000 }
              ]}>
              <Input.TextArea
                {...props}
                className="write-panel-textarea"
                placeholder="What do you think?"
                rows={4}
              />
            </Form.Item>
          </Flex>
          <Flex direction="column" rowGap={12} paddingTop={12}>
            <Text className="wp-label">Add a Title *</Text>
            <Text>What’s the most important others should know?</Text>
            <Form.Item
              name="title"
              style={{ width: '100%' }}
              // label={<Text size={16}>Nickname*</Text>}
              rules={[
                { required: true },
                { type: 'string', min: 1, max: 100 }
              ]}>
              <Input
                className="write-panel-input"
                placeholder="Write the title of your review here."
              />
            </Form.Item>
          </Flex>
          <Flex direction="column" rowGap={12} paddingTop={12}>
            <Text className="wp-label">About You*</Text>
            <Flex rowGap={8}>
              <Text>Your Email*</Text>
              <Form.Item
                name="email"
                style={{ width: '100%' }}
                //label={<Text>Your Email*</Text>}
                rules={[
                  { required: true },
                  {
                    pattern:
                      /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/,
                    message: 'Please enter the correct email'
                  }
                ]}>
                <Input
                  className="write-panel-input"
                  placeholder="We will only use email to verify our buyers"
                />
              </Form.Item>
            </Flex>
            <Flex rowGap={8}>
              <Text>Your Nickname*</Text>
              <Form.Item
                name="nickname"
                style={{ width: '100%' }}
                // label={<Text>Your Nickname*</Text>}
                rules={[{ required: true }, { type: 'string', min: 1 }]}>
                <Input
                  className="write-panel-input"
                  placeholder="Your nickname"
                />
              </Form.Item>
            </Flex>
          </Flex>
        </Form>
        <Flex paddingTop={12}>
          <Button
            aria-label="@hernest.com"
            style={{ width: '100%', height: 48 }}
            type="primary"
            onClick={async () => {
              await form.validateFields()
              const data = form.getFieldsValue()
              data.score = score
              console.log('reviewdata', data)
              onSubmit(data)
            }}>
            <Text size={16} color="#ffffff">
              Submit Review
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  )
}
const WritePanel = (props: { onSubmit }) => {
  const { onSubmit } = props

  const [form] = Form.useForm()

  const [score, setState] = React.useState(5)

  const ref = ctx.useRef()

  const [state] = ctx.useState()

  return (
    <Flex
      className="write-panel-form"
      direction="column"
      rowGap={32}
      padding={[24, 0]}>
      <Flex id="write-panel-head" colGap={16} warp={false}>
        <Image
          alt={state.productsName}
          preview={false}
          src={state.mainImage}
          width="80"
          height="80"
        />
        <Flex span="auto" direction="column" rowGap={8}>
          <Text size={14} className="write-panel-title">
            {state.productsName}
          </Text>
          <Rate
            value={score}
            onChange={(num) => {
              setState(num)
            }}
          />
        </Flex>
      </Flex>
      <Flex>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          style={{ width: '100%' }}>
          <Form.Item
            name="nickname"
            label={<Text size={16}>Nickname*</Text>}
            rules={[{ required: true }, { type: 'string', min: 1 }]}>
            <Input className="write-panel-input" placeholder="Your nickname" />
          </Form.Item>
          <Form.Item
            name="content"
            label={<Text size={16}>Add Your Review*</Text>}
            rules={[
              {
                required: true,
                message: 'Please enter the content of the comment'
              },
              { type: 'string', min: 6, max: 2000 }
            ]}>
            <Input.TextArea
              className="write-panel-textarea"
              placeholder="What do you think?"
              rows={8}
            />
          </Form.Item>
        </Form>
        <Button
          aria-label="@hernest.com"
          style={{ width: '100%', height: 48 }}
          type="primary"
          onClick={async () => {
            await form.validateFields()
            const data = form.getFieldsValue()
            data.score = score
            console.log('reviewdata', data)
            onSubmit(data)
          }}>
          <Text size={16} color="#ffffff">
            Submit Review
          </Text>
        </Button>
      </Flex>
    </Flex>
  )
}

const WriteSucess = (props: { onSubmit }) => {
  const { onSubmit } = props
  return (
    <Flex
      paddingTop={120}
      direction="column"
      rowGap={16}
      justify="center"
      alignItems="center">
      <img
        src={sucess}
        style={{ width: 188 }}
        alt="Thank You for Posting a Review!"
      />
      <Text className="wp-label">Thank You for Posting a Review!</Text>
      <Text>
        Your review was sent successfully and is now waiting for our staff to
        publish it.
      </Text>
      <Flex paddingTop={16}>
        <Button
          aria-label="@hernest.com"
          type="primary"
          style={{ width: '100%', height: 48 }}
          onClick={onSubmit}>
          <Text size={16} color="#ffffff">
            Continue Shopping
          </Text>
        </Button>
      </Flex>
    </Flex>
  )
}

function Index() {
  const ref = ctx.useRef()
  const [state, setState] = ctx.useState()
  const [writeState, useWrite] = React.useState({
    isWrite: false,
    loading: false
  })
  return (
    <>
      <Button
        aria-label="@hernest.com"
        onClick={ref.current.onWrite}
        className="widget-write-review"
        type="primary"
        icon={<Icon customSrc="icon-Write" />}>
        Write a Review
      </Button>
      <Drawer
        title={!writeState.isWrite && 'Write a Review'}
        width={480}
        placement="right"
        open={state.open}
        onClose={() => setState({ open: false })}
        closeIcon={<i className="iconfont icon-close common-drawer-close" />}
        children={
          <Switch either={!writeState.isWrite}>
            <Container isLoading={writeState.loading}>
              <WritePanelv2
                onSubmit={async (data) => {
                  useWrite({ ...writeState, loading: true })
                  await ref.current.onAddReview(data)
                  useWrite({ ...writeState, isWrite: true, loading: false })
                }}
              />
            </Container>
            <WriteSucess onSubmit={() => setState({ open: false })} />
          </Switch>
        }
        closable
        destroyOnClose
      />
    </>
  )
}

export default Index
